export const getters = {
  walletAccount: state => state.account,
  walletTransactions: state => state.transactions,
  walletPagination: state => state.pagination,
  walletLoading: state => state.loading,
  walletError: state => state.error
};
